import React from "react";
import { useDispatch } from "react-redux";
import "./products-filters.scss";
import { useNavigate } from "react-router-dom";
import {
  emptyIftCheckList,
  resetTextFilters,
  updatePriceValue,
  updateSortByValue,
} from "redux/actions";

const ProductsFilters = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <>
      <div className="main-filter-wrapper">
        <div
          className="clear-filter"
          onMouseDown={() => {
            dispatch(emptyIftCheckList());
            dispatch(resetTextFilters());
            dispatch(updateSortByValue(""))
            dispatch(updatePriceValue(["", ""]));
          }}
          onMouseUp={() => {
            navigate(`/search/products/`);
          }}
        >
          Clear
        </div>
      </div>
    </>
  );
};

export default ProductsFilters;
